module.exports = __webpack_public_path__ + "img/0Q3A2889_FoamcoreMatted.c7509442.jpg";